import {
  PREPARATION_TIME_CHOSEN,
  CREATE_ORDER_AND_USER,
  INIT_FUNCTION_PAYMENT,
  CALL_FUNCTION_PAYMENT,
  SEND_SESSION_PAY_PLUS,
  INIT_CALCUL_HOUR,
  FETCH_ORDER_DATA,
  CREATE_ORDER,
  ADD_COMMENTS,
  SEND_ORDER,
  INIT_ORDER,
  RESET_ORDER_TIME,
  UPDATE_PRODUCTS_IN_ORDER,
} from "../types/order.types";

import { deepClone } from "../../utils/utils";

const initialState = {
  selectedTimeTakeAway: false,
  initialSessionPayPlus: "",
  callFunction: false,
  calculHour: false,
  orderComment: "",
  orderSent: false,
  orderId: "",
};

const reducer = function orderReducer(state = initialState, action) {
  const newState = deepClone(state);
  switch (action.type) {
    case CREATE_ORDER_AND_USER:
      const order_id = action.response.order_id;
      const user_id = action.response.user_id;
      window.sessionStorage.setItem("ORDER_ID", order_id);
      window.localStorage.setItem("USER_ID", user_id);
      newState.orderId = order_id;
      newState.initialSessionPayPlus = "";
      newState.orderSent = false;
      return newState;
    case CREATE_ORDER:
      const newOrderId = action.response.order_id;
      window.sessionStorage.setItem("ORDER_ID", newOrderId);
      newState.initialSessionPayPlus = "";
      newState.orderSent = false;
      newState.orderId = newOrderId;
      return newState;
    case SEND_ORDER:
      newState.orderSent = true;
      return newState;
    case INIT_ORDER:
      window.sessionStorage.removeItem("ORDER_ID");
      newState.selectedTimeTakeAway = false;
      newState.initialSessionPayPlus = "";
      newState.callFunction = false;
      newState.orderComment = "";
      newState.orderSent = false;
      return newState;
    case RESET_ORDER_TIME:
      newState.selectedTimeTakeAway = false;
      newState.initialSessionPayPlus = "";
      newState.callFunction = false;
      return newState;
    case CALL_FUNCTION_PAYMENT:
      newState.callFunction = true;
      return newState;
    case INIT_FUNCTION_PAYMENT:
      newState.callFunction = false;
      return newState;
    case ADD_COMMENTS:
      const textValue = action.response;
      newState.orderComment = textValue;
      return newState;
    case PREPARATION_TIME_CHOSEN:
      const timeStamps = action.response;
      newState.selectedTimeTakeAway = timeStamps;
      newState.calculHour = true;
      return newState;
    case INIT_CALCUL_HOUR:
      newState.calculHour = false;
      return newState;
    case SEND_SESSION_PAY_PLUS:
      const { session } = action;
      newState.initialSessionPayPlus = session;
      return newState;
    case FETCH_ORDER_DATA:
      const { text, time } = action.response;
      newState.orderComment = text;
      newState.selectedTimeTakeAway = time;
      newState.calculHour = true;
      return newState;
    default:
      return newState;
  }
};

export default reducer;
